import { resetCDNCache } from '../api/cdn.js';
import { setOptions } from './options.js';
import { request } from './request.js';

const api = {
  get(url, requestOptions) {
    return request("get", url, requestOptions);
  },
  post(url, requestOptions) {
    return request("post", url, requestOptions);
  },
  put(url, requestOptions) {
    return request("put", url, requestOptions);
  },
  delete(url, requestOptions) {
    return request("delete", url, requestOptions);
  }
};
function getStoreIdentifier(storeIdentifier) {
  if (storeIdentifier) {
    return storeIdentifier;
  }
  if (window?.Shopify?.shop) {
    return window.Shopify.shop;
  }
  let domain = window?.domain;
  if (!domain) {
    const subdomain = location?.href.match(/(?:http[s]*:\/\/)*(.*?)\.(?=admin\.rechargeapps\.com)/i)?.[1].replace(/-sp$/, "");
    if (subdomain) {
      domain = `${subdomain}.myshopify.com`;
    }
  }
  if (domain) {
    return domain;
  }
  throw new Error(`No storeIdentifier was passed into init.`);
}
function initRecharge(opt = {}) {
  const hiddenOpts = opt;
  const { storefrontAccessToken } = opt;
  if (storefrontAccessToken && !storefrontAccessToken.startsWith("strfnt")) {
    throw new Error(
      "Incorrect storefront access token used. See https://storefront.rechargepayments.com/client/docs/getting_started/package_setup/#initialization-- for more information."
    );
  }
  setOptions({
    storeIdentifier: getStoreIdentifier(opt.storeIdentifier),
    loginRetryFn: opt.loginRetryFn,
    storefrontAccessToken,
    environment: hiddenOpts.environment ? hiddenOpts.environment : "prod",
    environmentUri: hiddenOpts.environmentUri
  });
  resetCDNCache();
}

export { api, initRecharge };
//# sourceMappingURL=init.js.map
